import { BasicCriteria, Language, LanguageWrapper } from '@wizeoo/akm-message-lib';
import { ViewData } from '../../../model/view.data';
import { LanguageVO } from '../../../vo/locale/language.vo';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';

/**
 * Appels Language (Find)
 * Author MDI
 */
export class LanguageCmd extends WizCommand<LanguageWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  // mémorisation de la source pour mise à jour sur retour service
  public sourceVO: LanguageVO = null;

  
  /** retourne le wrapper pré-alimenté */
  public LanguageWrapper(): LanguageWrapper {
    const wrapper: LanguageWrapper = new LanguageWrapper();
    wrapper.criteria = new BasicCriteria();
    wrapper.criteria.domain = ViewData.wildcardDomain;
    wrapper.criteria.businessUnitCode = ViewData.wildcardDomain;
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    return wrapper;
  }


  /** chargement de toutes les langues du domaine */
  public find(): LanguageCmd {
    const wrapper: LanguageWrapper = this.LanguageWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.LANGUAGE_API, wrapper);
    return this;
  }

  /**
   * retour de service
   * gestion de retour selon la méthode d'appelle
   */
  public wizResult(): void {
    super.wizResult();

    const wrapper: LanguageWrapper = this.result;
    if (!!wrapper?.entities) {
    // convertion de la liste de retour en liste de LanguageVO
    const languages: LanguageVO[] = wrapper.entities.map((element: Language) => new LanguageVO(this.model, element));

    this.model.languageList = languages;
    // construction de la map
    const languageMap = new Map();
    languages.reduce((map: Map<string, LanguageVO>, lang: LanguageVO) => {
      map.set(lang.code, lang);
      return map;
    }, languageMap);
    // Initialisation du model
    this.model.languageMap = languageMap;
    }
  }
}
